import React from 'react'
import { useState } from 'react'
import { ScaleLoader } from 'react-spinners'
import { AxiosPost } from '../../../../../context/UserContext'
import { pushNotify } from '../../../../../services/NotifyService'
import Select from "react-select";

function EquipmentLogs(props) {
  const initialFormData = { particulars: '', vendor_id: '', call_time: '', in_time: '', out_time: '', no_of_attendants: '', no_of_callsheets: '', shoot_date: '', nature_of_activity: '', quantity: '', remarks: '' }
  const [formData, setFormData] = useState(initialFormData)
  const [isLoading, setIsLoading] = useState(false);

  const onChangeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const formSubmitHandler = async (e) => {
    e.preventDefault();
    console.log(formData)
    setIsLoading(true);
    try {
      if (!Object.values(formData).every(val => {
        if (typeof (val) != 'object') {
          if (val.trim() == '') return false;
          else return true;
        }
        else {
          if (val != null) return true;
          else return false;
        }
      })) {
        pushNotify('error', 'Error', 'Please Fill in all Required Fields! in');
        return;
      }
      const data = await AxiosPost('add_equipment_logs.php', formData);
      if (data.success) {
        pushNotify('success', "Success", 'Bill Raised Successfully');
        setFormData(initialFormData);
      }
      else pushNotify('error', "Error", data.error);

    } catch (err) {
      pushNotify("error", "Error", "Server Error!");
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {
        isLoading ? <div className="row mx-0" style={{ height: "500px" }}><ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /></div>
          :
          <div className="basic-form">
            <form onSubmit={formSubmitHandler}>
              <div className="row">
                <div className="form-group mb-3 col-md-6">
                  <label>Particulars</label>
                  <input type="text" className="form-control" name='particulars' id='particulars' onChange={onChangeHandler} value={formData.particulars} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Vendor Username</label>
                  <Select
                    value={formData.vendor_id}
                    onChange={(e) => { setFormData({ ...formData, "vendor_id": e }) }}
                    options={props.vendorIdOptions}
                  />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Shoot Date</label>
                  <input type="date" className="form-control" name='shoot_date' id='shoot_date' onChange={onChangeHandler} value={formData.shoot_date} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Activity Type</label>
                  <input type="text" className="form-control" name='nature_of_activity' id='nature_of_activity' onChange={onChangeHandler} value={formData.nature_of_activity} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Quantity</label>
                  <input type="number" className="form-control" name='quantity' id='quantity' onChange={onChangeHandler} value={formData.quantity} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Call Time</label>
                  <input type="time" className="form-control" name='call_time' id='call_time' onChange={onChangeHandler} value={formData.call_time} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>In Time</label>
                  <input type="time" className="form-control" name='in_time' id='in_time' onChange={onChangeHandler} value={formData.in_time} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Out Time</label>
                  <input type="time" className="form-control" name='out_time' id='out_time' onChange={onChangeHandler} value={formData.out_time} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Number of Attendants</label>
                  <input type="number" className="form-control" name='no_of_attendants' id='no_of_attendants' onChange={onChangeHandler} value={formData.no_of_attendants} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Number of Call Sheets</label>
                  <input type="number" className="form-control" name='no_of_callsheets' id='no_of_callsheets' onChange={onChangeHandler} value={formData.no_of_callsheets} />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <label>Remarks</label>
                  <input type="text" className="form-control" name='remarks' id='remarks' onChange={onChangeHandler} value={formData.remarks} />
                </div>
              </div>
              <button type="submit" className="btn btn-primary">
                Add Log
              </button>
            </form>
          </div>
      }
    </>
  )
}

export default EquipmentLogs